import React, { useEffect, useState } from "react";
import {
  StyledViewerHead,
  StyledViewerWrap
} from './StyledViewerExperience';
import { Banner,Loader } from '../../components';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import {
  setLoader,
} from "../../redux/loader/loader.actions";
const ExperienceLeafeFour = () => {
  const history = useHistory()
  const heroImg = require('../../assets/header-experience.jpg');
  const arrayLoad = [
    heroImg
  ]
  const dispatch = useDispatch();

  const handleCLick = (slug) => {
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
  }
  const handleWinScroll = (isEnter) => {
    document.querySelector('body').style.overflow = isEnter ? 'hidden' : 'scroll';
  }
  return(
    <React.Fragment>
    <section>
      <StyledViewerHead>
        <p className="preset-10">CPG</p>
        <h6 className="md--title">Useful</h6>
      </StyledViewerHead>
      <StyledViewerWrap>
        <div className="viewer-content">
          <div className="arrow-wrap prev" onClick={() => handleCLick('/3d-commerce-experience/item-3')}>
            <img src={require('../../assets/3dexperience/arrow-black-prev.png')} />
          </div>
          <div className="arrow-wrap next" onClick={() => handleCLick('/3d-commerce-experience/configurator')}>
            <img src={require('../../assets/3dexperience/arrow-black-next.png')} />
          </div>
          <div className="iframe-wrap" onMouseEnter={() => handleWinScroll(true)} onMouseLeave={() => handleWinScroll(false)}>
            <iframe src="/viewer_barilla/index.html" />
          </div>
          <div className="viewer-text">
            <div className="viewer-row">
              <img src={require('../../assets/3dexperience/rating.jpg')} />
              <p className="preset-11 grey-400">37 Reviews</p>
            </div>
            <div className="viewer-row">
              <p className="preset-9 blue">&euro; 12,30</p>
            </div>
            <div className="viewer-row">
              <p className="preset-11 ">
                <b className="blue">Pasta sauce</b><br/>
              </p>
            </div>
            <div className="viewer-row">
              <p className="preset-11 ">
                <span className="grey-400">Every Barila sauce is made with only the highest quality ingredients like: vine-ripened tomatoes, aromatic herbs, and extra virgin olive oil.</span>
              </p>
            </div>
            <div className="viewer-row">
              <p className="preset-11 ">
                *3D Pasta Sauce made for Barilla
              </p>
            </div>
            <div className="viewer-row">
            <img src={require('../../assets/3dexperience/buy-button.jpg')} />
            </div>
          </div>
        </div>
      </StyledViewerWrap>
      <div className="side--quote-wrap no-margin-btm">
        <div className="side--title">
          <h6 className="md--title">Empower your ecommerce</h6>
          <img src={require('../../assets/3dexperience/logo_3DCommerce.jpg')} />
        </div>
        <p className="preset-9 side--text">
        Feature the 3D real-time rendered Digital Twin in your online strategy to let your customers experience the difference.
        <br/><br/>
        Made up of ultra-realistic textures, physics and materials, these real-time renders are multi-channel, customizable, and easily embeddable through viewers and configurators.
        </p>
      </div>
    </section>
    <Banner 
      text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" 
    />
    <Loader arrayLoad={arrayLoad} />
  </React.Fragment>
  );
}

export default ExperienceLeafeFour;